
import React, { useState, useEffect } from "react";

export default function DigitalLibrary() {
  const [folders, setFolders] = useState([
    { name: "Homework", files: [{ name: "Math_Worksheet.pdf", type: "doc" }, { name: "Science_Notes.docx", type: "doc" }] },
    { name: "Projects", files: [{ name: "Volcano_Project.jpg", type: "img" }, { name: "Robotics_Presentation.mp4", type: "vid" }] },
    { name: "Fun Stuff", files: [{ name: "Birthday_Party.png", type: "img" }, { name: "Dance_Video.mp4", type: "vid" }] }
  ]);

  const [newFolderName, setNewFolderName] = useState("");
  const [newFileName, setNewFileName] = useState("");
  const [fileType, setFileType] = useState("doc");
  const [selectedFolder, setSelectedFolder] = useState("");
  const [removeFolder, setRemoveFolder] = useState("");
  const [removeFileFolder, setRemoveFileFolder] = useState("");
  const [removeFileName, setRemoveFileName] = useState("");
  const [moveFileName, setMoveFileName] = useState("");
  const [moveFrom, setMoveFrom] = useState("");
  const [moveTo, setMoveTo] = useState("");

  const [openFolders, setOpenFolders] = useState({});

  const toggleFolder = (folderName) => {
    setOpenFolders((prev) => ({ ...prev, [folderName]: !prev[folderName] }));
  };

  const addFolder = () => {
    if (!newFolderName.trim()) return alert("Please enter a folder name!");
    setFolders([...folders, { name: newFolderName, files: [] }]);
    setNewFolderName("");
  };

  const addFile = () => {
    if (!newFileName.trim()) return alert("Please enter a file name!");
    setFolders(
      folders.map((f) =>
        f.name === selectedFolder ? { ...f, files: [...f.files, { name: newFileName, type: fileType }] } : f
      )
    );
    setNewFileName("");
  };

  const removeFolderFn = () => {
    setFolders(folders.filter((f) => f.name !== removeFolder));
  };

  const removeFileFn = () => {
    setFolders(
      folders.map((f) =>
        f.name === removeFileFolder
          ? { ...f, files: f.files.filter((file) => !file.name.includes(removeFileName)) }
          : f
      )
    );
    setRemoveFileName("");
  };

  const moveFileFn = () => {
    if (!moveFileName.trim() || moveFrom === moveTo) return;
    let movedFile = null;
    const updatedFolders = folders.map((f) => {
      if (f.name === moveFrom) {
        const newFiles = f.files.filter((file) => {
          if (file.name.includes(moveFileName)) {
            movedFile = file;
            return false;
          }
          return true;
        });
        return { ...f, files: newFiles };
      }
      return f;
    });

    if (movedFile) {
      setFolders(
        updatedFolders.map((f) =>
          f.name === moveTo ? { ...f, files: [...f.files, movedFile] } : f
        )
      );
    }
    setMoveFileName("");
  };

  // ---------- Inline Styles ----------
  const styles = {
    body: {
      fontFamily: "Segoe UI, sans-serif",
      background: "linear-gradient(to bottom right, #dbeafe, #e0f2fe)",
      padding: "20px",
    },
    h1: {
      textAlign: "center",
      color: "#2c3e9d",
      fontSize: "2.2em",
      marginBottom: "20px",
      textShadow: "1px 1px 3px #fff",
    },
    folder: {
      cursor: "pointer",
      margin: "10px 0",
      padding: "12px",
      fontWeight: "bold",
      color: "#2c3e9d",
      background: "#fff",
      borderRadius: "8px",
      boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
      transition: "transform 0.2s, background 0.3s",
    },
    folderHover: {
      background: "#f0f7ff",
      transform: "translateX(5px)",
    },
    files: { marginLeft: "30px", marginTop: "8px" },
    file: {
      margin: "6px 8px 6px 0",
      padding: "6px 12px",
      borderRadius: "6px",
      display: "inline-block",
      fontSize: "0.95em",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    },
    doc: { background: "#cce0ff", color: "#003366" },
    img: { background: "#d9fcd9", color: "#004d00" },
    vid: { background: "#ffd6f0", color: "#660033" },
    controls: {
      maxWidth: "800px",
      margin: "30px auto 0",
      padding: "15px 20px",
      background: "#fff8e6",
      border: "2px solid #ffd580",
      borderRadius: "12px",
      boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
    },
    h2: { marginTop: 0, color: "#cc6600" },
    input: {
      margin: "6px",
      padding: "6px 10px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      fontSize: "0.9em",
    },
    button: {
      margin: "6px",
      padding: "6px 10px",
      borderRadius: "6px",
      background: "#4f46e5",
      color: "white",
      border: "none",
      cursor: "pointer",
      fontSize: "0.9em",
      transition: "background 0.3s",
    },
  };

  return (
    <div style={styles.body}>
      <h1 style={styles.h1}>📚 My Digital Library</h1>

      <div id="library" style={{ maxWidth: "800px", margin: "auto" }}>
        {folders.map((folder) => (
          <div key={folder.name}>
            <div
              style={styles.folder}
              onClick={() => toggleFolder(folder.name)}
            >
              📁 {folder.name}
            </div>
            {openFolders[folder.name] && (
              <div style={styles.files}>
                {folder.files.map((file, i) => (
                  <div
                    key={i}
                    style={{ ...styles.file, ...(file.type === "doc" ? styles.doc : file.type === "img" ? styles.img : styles.vid) }}
                  >
                    {file.type === "doc" ? "📄" : file.type === "img" ? "🖼️" : "🎬"} {file.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <div style={styles.controls}>
        <h2 style={styles.h2}>✨ Manage Your Library</h2>

        {/* Add Folder */}
        <label>New Folder Name: </label>
        <input
          style={styles.input}
          type="text"
          value={newFolderName}
          onChange={(e) => setNewFolderName(e.target.value)}
          placeholder="e.g., Music"
        />
        <button style={styles.button} onClick={addFolder}>Add Folder</button>
        <br />

        {/* Add File */}
        <label>Choose Folder: </label>
        <select
          style={styles.input}
          value={selectedFolder}
          onChange={(e) => setSelectedFolder(e.target.value)}
        >
          {folders.map((f) => (
            <option key={f.name}>{f.name}</option>
          ))}
        </select>
        <br />
        <label>File Name: </label>
        <input
          style={styles.input}
          type="text"
          value={newFileName}
          onChange={(e) => setNewFileName(e.target.value)}
          placeholder="e.g., Song.mp3"
        />
        <label>Type: </label>
        <select
          style={styles.input}
          value={fileType}
          onChange={(e) => setFileType(e.target.value)}
        >
          <option value="doc">Document 📄</option>
          <option value="img">Image 🖼️</option>
          <option value="vid">Video 🎬</option>
        </select>
        <button style={styles.button} onClick={addFile}>Add File</button>
        <br /><br />

        {/* Remove Folder */}
        <label>Remove Folder: </label>
        <select
          style={styles.input}
          value={removeFolder}
          onChange={(e) => setRemoveFolder(e.target.value)}
        >
          {folders.map((f) => (
            <option key={f.name}>{f.name}</option>
          ))}
        </select>
        <button style={styles.button} onClick={removeFolderFn}>Remove</button>
        <br />

        {/* Remove File */}
        <label>From Folder: </label>
        <select
          style={styles.input}
          value={removeFileFolder}
          onChange={(e) => setRemoveFileFolder(e.target.value)}
        >
          {folders.map((f) => (
            <option key={f.name}>{f.name}</option>
          ))}
        </select>
        <input
          style={styles.input}
          type="text"
          value={removeFileName}
          onChange={(e) => setRemoveFileName(e.target.value)}
          placeholder="Enter file name"
        />
        <button style={styles.button} onClick={removeFileFn}>Remove File</button>
        <br />

        {/* Move File */}
        <label>Move File: </label>
        <input
          style={styles.input}
          type="text"
          value={moveFileName}
          onChange={(e) => setMoveFileName(e.target.value)}
          placeholder="Enter file name"
        />
        <label>From: </label>
        <select
          style={styles.input}
          value={moveFrom}
          onChange={(e) => setMoveFrom(e.target.value)}
        >
          {folders.map((f) => (
            <option key={f.name}>{f.name}</option>
          ))}
        </select>
        <label>To: </label>
        <select
          style={styles.input}
          value={moveTo}
          onChange={(e) => setMoveTo(e.target.value)}
        >
          {folders.map((f) => (
            <option key={f.name}>{f.name}</option>
          ))}
        </select>
        <button style={styles.button} onClick={moveFileFn}>Move</button>
      </div>
    </div>
  );
}

